"use client";

import { useCallback, useEffect, useRef, useState } from "react";

export function useScrollToTop(threshold = 300) {
	const [isVisible, setIsVisible] = useState(() => {
		if (typeof window !== "undefined") {
			return window.scrollY > threshold;
		}
		return false;
	});
	const isMounted = useRef(false);

	useEffect(() => {
		isMounted.current = true;

		const onScroll = () => {
			if (isMounted.current) {
				setIsVisible(window.scrollY > threshold);
			}
		};

		window.addEventListener("scroll", onScroll, { passive: true });
		return () => {
			isMounted.current = false;
			window.removeEventListener("scroll", onScroll);
		};
	}, [threshold]);

	const scrollToTop = useCallback(() => {
		window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);

	return { isVisible, scrollToTop };
}
